import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { footerOptions } from '../../../config/footer-menu';

const FooterWrapper = styled.footer`
`;

const Container = styled.div`
  width: 100%;
  padding-top: 1.5rem;
  padding-bottom: 2rem;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const LogoBlock = styled.div`
  margin-bottom: 2rem;
`;

const Logo = styled.img`
  height: 32px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.5rem;
  }
`;

const Section = styled.div``;

const SectionTitle = styled.h2`
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
`;

const List = styled.ul`
  font-weight: 500;
  color: oklch(0.707 0.022 261.325);
`;

const ListItem = styled.li`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Divider = styled.hr`
  margin: 1.5rem 0;
  border: none;
  border-top: 1px solid oklch(37.3% 0.034 259.733);
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 0.875rem;
  color: #6b7280;
`;

export const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <Container>
        <TopRow>
          <LogoBlock>
            <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
              <Logo src="/logo.png" alt="Логотип Plumme" />
            </Link>
          </LogoBlock>
          <Grid>
            {footerOptions.map(section => (
              <Section key={section?.id}>
                <SectionTitle>{section.title}</SectionTitle>
                <List>
                    {section.items.map((item) => (
                        <ListItem key={item.id}>
                            {item.href.startsWith('/') ? (
                                <Link to={item.href}>{item.label}</Link>
                            ) : (
                                <a href={item.href} target="_blank" rel="noopener noreferrer">{item.label}</a>
                            )}
                        </ListItem>
                    ))}
                </List>
              </Section>
            ))}
          </Grid>
        </TopRow>

        <Divider />

        <BottomRow>
          © 2026 <Link to="/" style={{ marginLeft: 4, color: 'inherit', textDecoration: 'none' }}>Plumme™</Link>. Все права защищены
        </BottomRow>
      </Container>
    </FooterWrapper>
  );
};